import {type FC, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useCurrentRoute} from '~/CreateFabricInvitation/navigation';
import {
  selectAllBackgroundsLoaded,
  selectForceShowOnboardingModal,
} from '~/CreateFabricInvitation/reducers/fabricDesign/selectors';
import {NavBottom} from '~/common/FabricInvitation/EventCreateDesign/components/NavBottom/NavBottom';
import {Onboarding} from '~/common/FabricInvitation/EventCreateDesign/components/Onboarding/Onboarding';
import {EventCreateStickerParent} from '~/common/FabricInvitation/EventCreateDesign/components/Sticker/EventCreateStickerContext';
import {EventCreateParent} from '~/common/FabricInvitation/EventCreateDesign/EventCreateContext';
import {EventCreateDesign} from '~/common/FabricInvitation/EventCreateDesign/EventCreateDesign';
import {FontProvider} from '~/common/FabricInvitation/EventCreateDesign/FontProvider';
import {selectTemplateName} from '~/common/fabric/reducers/fabricTemplate/selector';
import {useIsLargishAndUp} from '~/common/hooks/useMatchQuery';
import {ContentIdentifiers} from '~library/shared/enums/ContentIdentifiers';
import {TrackingEvents} from '~library/shared/enums/TrackingEvents';
import {sendTrackingData} from '~library/utils/tracking';

import './CreateInvitationCreateDesign.sass';

interface CreateInvitationCreateDesignProps {
  hideBottomNav?: boolean;
}

export const CreateInvitationCreateDesign: FC<CreateInvitationCreateDesignProps> = ({
  hideBottomNav = false,
}) => {
  const forceShowOnboardingModal = useSelector(selectForceShowOnboardingModal);
  const allBackgroundsLoaded = useSelector(selectAllBackgroundsLoaded);
  const isDesktop = useIsLargishAndUp();
  const currentRoute = useCurrentRoute();
  const templateName = useSelector(selectTemplateName);

  useEffect(() => {
    sendTrackingData(TrackingEvents.ContentLoadTracking, {
      identifier: ContentIdentifiers.CreateEditInvitationCreateDesign,
      attributes: {templateName},
    });
  }, [templateName]);

  return (
    <EventCreateParent>
      {forceShowOnboardingModal && <Onboarding />}
      <EventCreateStickerParent>
        <FontProvider>
          <EventCreateDesign scrollable={isDesktop} showAds={false}>
            {isDesktop && !hideBottomNav && (
              <NavBottom allBackgroundsLoaded={allBackgroundsLoaded} currentRoute={currentRoute} />
            )}
          </EventCreateDesign>
        </FontProvider>
      </EventCreateStickerParent>
    </EventCreateParent>
  );
};
